import styled from 'styled-components';

const Errors = styled.div`
  
`

export default function Error( {errors} ) {
  return (
    <Errors className="errors">
      {errors.map((error) => { 
        return (
            <div key={Math.random()}>{error}</div>
          )
        }
      )}
    </Errors>
  )
}
